import axios from "axios";
import axiosApi from "../api/axiosInstance";
import {
  createComplaint_API_URL_V2,
  RequestOTP_URL,
  VerifyOTP_URL,
  CustomerProfile_URL,
  GetDeliveryLocation_API_URL_V2,
  DeleteDeliveryLocation_API_V2_URL,
} from "./config";

// This function saves the delivery location using the Zulal Web API
export const saveDeliveryLocation = async (data) => {
  const url = "/api/v2/customer/saveDeliveryLocation";
  const response = await axiosApi.post(url, data, {
    withCredentials: true,
    // optional during debugging; remove if you want global 401 handling
    // skipUnauthorizedEvent: true,
  });
  return response.data;
};

export const updateDeliveryLocation = async (data) => {
  const url = "/api/v2/customer/updateDeliveryLocation";
  const response = await axiosApi.post(url, data, {
    withCredentials: true,
    // optional during debugging
    // skipUnauthorizedEvent: true,
  });
  return response.data;
};

// This function fetches the delivery locations using the Zulal Web API
// export const getDeliveryLocations = async (data) => {
//   try {
//     console.log(`customer Code from Zulal Web API: ${data.customerCode}`);
//     const response = await axios.get(GetDeliveryLocation_API_URL, {
//       params: {
//         customerCode: data.customerCode,
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching delivery locations: ", error.message);
//     throw error;
//   }
// };

export const getDeliveryLocations = async (customerCode) => {
  try {
    //    console.log(`customerCode from Zulal Web API: ${customerCode}`);
    const url = "/api/v2/customer/getDeliveryLocations";
    const response = await axiosApi.get(url);

    // console.log("******************");
    // console.log(response.status);
    // console.log("******************");

    if (response.status === 200) {
      return response.data.locations || [];
    } else {
      return [];
    }
  } catch (error) {
    return {
      status: "error",
      message: error.message,
      data: [],
    };
  }
};

export const getDeliveryLocationsV2 = async () => {
  try {
    //    console.log(`customerCode from Zulal Web API: ${customerCode}`);

    const response = await axiosApi.get(GetDeliveryLocation_API_URL_V2);

    // console.log("******************");
    // console.log(response.status);
    // console.log(response.data.locations);
    // console.log("******************");

    // response.data.locations already contains the normalized V1 structure
    if (response.data && response.data.locations) {
      return response.data.locations; // This already has { status, message, data }
    }

    // Fallback if locations is not present
    // console.warn("Unexpected response structure:", response.data);
    return {
      status: "error",
      message: "Invalid response structure",
      data: [],
    };
  } catch (error) {
    return {
      status: "error",
      message: error.message,
      data: [],
    };
  }
};

// This function update the delivery location using the Zulal Web API
// export const updateDeliveryLocation = async (data) => {
//   try {
//     // console.log("data for correction");
//     // console.log(data);
//     // console.log("*************");

//     const response = await axios.post(UpdateDeliveryLocation_API_V2_URL, data, {
//       withCredentials: true,
//     });
//     return response.data;
//   } catch (error) {
//     // console.error("Error updating delivery location: ", error.message);
//     throw error;
//   }
// };

// This function delete the delivery location using the Zulal Web API
// export const deleteDeliveryLocation = async (data) => {
//   try {
//     const response = await axios.delete(DeleteDeliveryLocation_API_V2_URL, {
//       data: data,
//       withCredentials: true, // Include credentials if needed
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error deleting delivery location: ", error.message);
//     throw error;
//   }
// };

// This function delete the delivery location using the Zulal Web API
export const deleteDeliveryLocation = async (locationId) => {
  try {
    // console.log("Deleting delivery location with ID:", locationId);

    // ✅ This will now match router.delete() in backend
    const response = await axiosApi.delete(DeleteDeliveryLocation_API_V2_URL, {
      data: { locationId },
    });

    // console.log("Delete location response:", response.data);
    return response.data;
  } catch (error) {
    // console.error("Error deleting delivery location:", error);

    if (error.response) {
      // console.error("Server error:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to delete location"
      );
    } else if (error.request) {
      // console.error("No response received:", error.request);
      throw new Error("No response from server");
    } else {
      // console.error("Error:", error.message);
      throw error;
    }
  }
};

// create a function to create a complaint using the Zulal Web API
// create a function to create a complaint using the Zulal Web API
export const createComplaint = async ({ description, file }) => {
  try {
    const CREATE_COMPLAINT_API_URL = createComplaint_API_URL_V2;

    const formData = new FormData();

    formData.append("description", description);
    if (file) {
      formData.append("file", file);
    }

    const response = await axiosApi.post(CREATE_COMPLAINT_API_URL, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    // console.error("Error creating complaint: ", error.message);
    throw error;
  }
};

class ApiError extends Error {
  constructor({
    message,
    status = null,
    data = null,
    retryAfter = null,
    originalError = null,
  }) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
    this.retryAfter = retryAfter;
    this.originalError = originalError;
    this.isApiError = true;
  }
}

// Function to request OTP using the Zulal Web API
/**
 * requestOTP
 * - Calls backend to request an OTP for mobileNumber
 * - On success returns response.data
 * - On failure throws ApiError with structured fields (status, data, retryAfter)
 */
export const requestOTP = async (mobileNumber) => {
  try {
    // const url = process.env.REACT_APP_ZULAL_API_URL + RequestOTP_URL;
    // console.log("Final URL for requestOTP:", url);

    // console.log("Requesting OTP for mobile number:", mobileNumber);

    const response = await axiosApi.post(RequestOTP_URL, {
      phone: mobileNumber,
    });
    // console.log("Checking requestOTP response:");
    // console.log(response.data);
    // console.log("End of requestOTP response");

    return response.data;
  } catch (err) {
    // Default fallback error
    let message = err?.message || "Request failed";
    let status = null;
    let data = null;
    let retryAfter = null;

    // Axios error specifics
    if (axios.isAxiosError(err)) {
      if (err.response) {
        status = err.response.status;
        data = err.response.data;
        // prefer server-provided message
        message =
          (err.response.data &&
            (err.response.data.message || err.response.data.error)) ||
          message;

        // If server provided Retry-After header, parse it (seconds or HTTP-date)
        const retryHeader =
          err.response.headers &&
          (err.response.headers["retry-after"] ||
            err.response.headers["Retry-After"]);
        if (retryHeader) {
          const asInt = parseInt(retryHeader, 10);
          if (!Number.isNaN(asInt)) {
            retryAfter = Math.max(0, asInt);
          } else {
            const parsed = Date.parse(retryHeader);
            if (!Number.isNaN(parsed)) {
              retryAfter = Math.max(0, Math.ceil((parsed - Date.now()) / 1000));
            }
          }
        }
      } else if (err.request) {
        // request made but no response received
        message = "No response from server. Please check your network.";
      } else {
        // something happened setting up the request
        message = err.message || message;
      }
    } else {
      // Non-Axios error
      message = err?.message || message;
    }

    throw new ApiError({
      message,
      status,
      data,
      retryAfter,
      originalError: err,
    });
  }
};

export const verifyOTP = async (mobileNumber, otp) => {
  try {
    // Use the api instance so cookies (and credentials) are handled correctly
    const response = await axiosApi.post(VerifyOTP_URL, {
      phone: mobileNumber,
      otp: otp,
    });

    return response.data;
  } catch (err) {
    // console.log("verifyOTP error:", err);

    let message = err?.message || "Request failed";
    let status = null;
    let data = null;
    let retryAfter = null;

    if (axios.isAxiosError(err)) {
      if (err.response) {
        status = err.response.status;
        data = err.response.data;
        message =
          (err.response.data &&
            (err.response.data.message || err.response.data.error)) ||
          message;

        // Parse Retry-After header (seconds or HTTP-date) when present
        const retryHeader =
          err.response.headers &&
          (err.response.headers["retry-after"] ||
            err.response.headers["Retry-After"]);
        if (retryHeader) {
          const asInt = parseInt(retryHeader, 10);
          if (!Number.isNaN(asInt)) {
            retryAfter = Math.max(0, asInt);
          } else {
            const parsed = Date.parse(retryHeader);
            if (!Number.isNaN(parsed)) {
              retryAfter = Math.max(0, Math.ceil((parsed - Date.now()) / 1000));
            }
          }
        }
      } else if (err.request && !err.response) {
        // request made but no response received
        message =
          "No response from server. Please check your network or server.";
      } else {
        // something happened setting up the request
        message = err.message || message;
      }
    } else {
      // Non-Axios error
      message = err?.message || message;
    }

    throw new ApiError({
      message,
      status,
      data,
      retryAfter,
      originalError: err,
      isApiError: true,
    });
  }
};

export const getCustomerProfile = async (token) => {
  try {
    const response = await axiosApi.get(CustomerProfile_URL);
    // console.log("Customer Profile Response from ZulalAPI.js");
    // console.log(response.data);
    // console.log("End of Customer Profile Response");

    return response.data;
  } catch (err) {
    // console.error("Error fetching customer profile: ", err.message);
    // console.log(err);

    let message = err?.message || "Request failed";
    let status = null;
    let data = null;
    let retryAfter = null;
    // // Axios error specifics
    if (axios.isAxiosError(err)) {
      if (err.response) {
        status = err.response.status;
        data = err.response.data;
        //     // prefer server-provided message
        message =
          (err.response.data &&
            (err.response.data.message || err.response.data.error)) ||
          message;
      }
    }

    throw new ApiError({
      message,
      status,
      data,
      retryAfter,
      originalError: err,
    });
  }
};

// authenticate and get current user details by passking Zulal Web API token
export const authAndgetCurrentUser = async (token) => {
  try {
    const response = await axiosApi.get("/api/v2/customer/authAndVerify");

    return response.data;
  } catch (err) {
    // console.error("Error fetching current user: ", err.message);
    throw err;
  }
};

// Create wallet top-up order
export const createWalletTopUpOrder = async (payload) => {
  try {
    // console.log("Creating wallet top-up order with payload:", payload);

    const response = await axiosApi.post(
      "/api/v2/customer/walletTopUp",
      payload
    );

    // console.log("Top-up order response:", response.data);
    return response.data;
  } catch (error) {
    // console.error("Error creating wallet top-up order:", error);

    if (error.response?.data) {
      throw new Error(
        error.response.data.message || "Failed to create top-up order"
      );
    }

    throw error;
  }
};

// Zulal Wallet Top-Up Confirmation
export const postTopUpConfirmation = async (orderId) => {
  try {
    const response = await axiosApi.post(
      `/api/v2/customers/topupconfirmation?orderId=${orderId}`
    );
    return response.data;
  } catch (error) {
    // console.error("Error confirming wallet top-up:", error);

    if (error.response?.data) {
      throw new Error(
        error.response.data.message || "Failed to confirm wallet top-up"
      );
    }

    throw error;
  }
};
